import { CheckboxComponent, SliderComponent } from '@vivli/shared/components';
import React, { useEffect, useState } from 'react';
import { IOrganizationRoles, IUser } from '@vivli/shared/infrastructure/interface';
import { useOrganizationDetailsContext } from '@vivli/features/organizations/infrastructure/context';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';
import { useActiveUserContext } from '@vivli/core/infrastructure/context';

export const OrgMemberCheckBoxRendererView = ({ data, column, orgId, inputStyle, isSlider = false }) => {
    const { hasPermission } = useActiveUserContext();
    const [userToUpdate, setUserToUpdate] = useState<IUser>(data.userRole);
    const fieldName = column.getColDef().field;
    const [isLoading, setIsLoading] = useState<boolean>();
    const [currentOrgRoles, setCurrentOrgRoles] = useState<IOrganizationRoles>();
    const [currentRoleValue, setCurrentRoleValue] = useState<boolean>();

    let onClick = () => {};
    if (orgId !== 'N/A') {
        const { updatedUser, handleRoleUpdate } = useOrganizationDetailsContext();
        onClick = () => {
            setIsLoading(true);
            handleRoleUpdate(orgIdToUse, fieldName, userToUpdate, setIsLoading);
            setIsLoading(false);
        };
        useEffect(() => {
            if (updatedUser?.id === userToUpdate.id) {
                setUserToUpdate(updatedUser.userRole);
            }
        }, [updatedUser]);
    }
    const isDisabled = orgId === 'N/A'; //for user details
    const orgIdToUse = orgId === 'N/A' ? data.id : orgId;

    useEffect(() => {
        if (!orgId || !userToUpdate) {
            return;
        }

        const _currentOrgRoles = userToUpdate.orgMemberships.find((m) => m.orgId === orgIdToUse);
        if (_currentOrgRoles) {
            setCurrentOrgRoles(_currentOrgRoles);
            if (fieldName.includes('hasRole')) {
                let value = data[fieldName];
                if (fieldName == 'hasRoleCurator' && !value) {
                    value = data['HeadCurator'];
                }
                setCurrentRoleValue(value);
            } else {
                //"normal" column
                setCurrentRoleValue(data[fieldName]);
            }
        }
    }, [orgId, userToUpdate]);

    //TODO PERMFE - redo with permissions+
    if (isSlider) {
        return (
            <SliderComponent
                onChange={onClick}
                disabled={
                    isDisabled ||
                    !hasPermission(PermissionsEnum.CreateOrg) ||
                    isLoading ||
                    (fieldName === 'notifyAsOrgAdmin' &&
                        (!currentOrgRoles?.vivliRoles?.find((role) => role.code == 'OrgAdmin') || currentOrgRoles?.isEnabled !== true)) ||
                    data.disabled === true
                }
                checked={currentRoleValue}
                id={userToUpdate.id + fieldName}
                style={{ ...inputStyle, paddingTop: 0, paddingLeft: 0 }}
            />
        );
    }
    return (
        <CheckboxComponent
            onChange={onClick}
            disabled={
                isDisabled ||
                !hasPermission(PermissionsEnum.CreateOrg) ||
                isLoading ||
                data.disabled === true ||
                currentOrgRoles?.isEnabled !== true
            }
            checked={currentRoleValue}
            style={inputStyle}
        />
    );
};
